import { TaskContextInterface } from './Interfaces/CWA/TaskContextInterface';
import { Worker } from './Worker';
import { CLSyncInterface } from './Interfaces/CLSyncInterface';
import { ApiGatewayClient } from './ApiGatewayClient';
import { callSyncNative } from './NativeFunctions';
import { FileStorageClient } from './FileStorageClient';

interface CapabilityFunction {
	name: keyof CLSyncInterface;
	args: {
		[key: string]: any;
	};
	async: boolean;
	return: 'string' | 'void'; // we perform bridge communication using JSON strings only
}

export interface Capabilities {
	functions: CapabilityFunction[];
}

export const capabilities: Capabilities = {
	functions: [
		{
			name: 'startCLSync',
			args: {
				arg0: 'jsonString',
			},
			async: false,
			return: 'void',
		},
		{
			name: 'stopCLSync',
			args: {},
			async: false,
			return: 'void',
		},
		{
			name: 'updateCLSync',
			args: {
				arg0: 'jsonString',
			},
			async: false,
			return: 'void',
		},
		{
			name: 'getCapabilities',
			args: {},
			async: false,
			return: 'string',
		},
	],
};

//Update capabilities JSON before modifying this class
export default class CLSyncEngine implements CLSyncInterface {
	private static instance: CLSyncEngine;
	private worker: Worker;
	static getInstance(): CLSyncInterface {
		if (!this.instance) {
			this.instance = new CLSyncEngine();
		}
		return this.instance;
	}

	public startCLSync(args: string): void {
		try {
			if (!this.worker) {
				const taskContext = JSON.parse(args) as TaskContextInterface;
				const fileStorage = new FileStorageClient();
				const apiClient = new ApiGatewayClient(taskContext);
				this.worker = new Worker(fileStorage, apiClient, taskContext);
				this.worker.startSync();
			} else {
				this.stopCLSync();
				this.updateCLSync(args);
				this.worker.startSync();
			}
		} catch (e) {
			callSyncNative('writeErrorMessage', e, Date.now());
			throw e;
		}
	}

	public stopCLSync(): void {
		try {
			if (this.worker) this.worker.stopSync();
		} catch (e) {
			callSyncNative('writeErrorMessage', e, Date.now());
			throw e;
		}
	}

	public updateCLSync(args: string): void {
		try {
			const taskContext = JSON.parse(args) as TaskContextInterface;
			this.worker.setTaskContext(taskContext);
		} catch (e) {
			callSyncNative('writeErrorMessage', e, Date.now());
			throw e;
		}
	}

	public getCapabilities(): string {
		return JSON.stringify(capabilities);
	}

	//Update capabilities JSON before adding a new function
}
